<script>
    import { onMount, setContext } from "svelte";
    import { withResolvers } from "@otto-ec/assets-core-utils/promise";
    import Cinema from "../components/Cinema.svelte";
    import { renderProductLineRecommendationsInternal } from "../services/nexusInternal/internalNexusEvents.js";
    import { getFeatureOrder } from "../utils/externalTrackingHelper.js";
    import { key as cinemaDimensionsDisplayCtxKey } from "../context/dimensionsDisplay.js";

    let { data } = $props();

    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");

    let trackingEventMergeId = $state(null);
    let refreshingDomClass = $state("");
    let cinemaContainer;
    const [cinemaContainerMounted, mountSuccess] = withResolvers();
    setContext(cinemaDimensionsDisplayCtxKey, data?.dimensionsDisplay);
    onMount(() => {
        featureIndex = getFeatureOrder(cinemaContainer);
        cinemaInjectionContainerWidth = cinemaContainer.offsetWidth || 1000;

        return renderProductLineRecommendationsInternal?.sub(
            async (detail) => {
                trackingEventMergeId = detail?.eventMergeId;
                mountSuccess();
            },
            { once: true }
        );
    });
</script>

<div bind:this={cinemaContainer}>
    {#if data}
        <div class="reco_product_line_cinema_wrapper{refreshingDomClass}">
            <Cinema
                headline={data.headline}
                recommendations={data.recommendations}
                tracking={data.tracking}
                {featureIndex}
                additionalClickTracking={data.additionalClickTracking}
                featuresState={data.featuresState}
                {cinemaInjectionContainerWidth}
                cinemaMeta={data.metaData}
                {trackingEventMergeId}
                loadedTrackingActionName="change"
                showTopInfo={true}
                personalisedUser={data.hasPersonalisedRecommendations || false}
                {cinemaContainerMounted}
            />
        </div>
    {/if}
</div>

<style lang="scss">
    .reco_product_line_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;

        &__loading {
            pointer-events: none;
            opacity: 0.5;
        }
    }
</style>
